import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios' // ### this line is important for destroy :) 'protocol' ERROR ###
import cryptojs from 'crypto-js';
import router from '@/router';

Vue.use(Vuex);
Vue.use(VueAxios, axios) // Vue.use(axios);
// Vue.use(axios);
export default new Vuex.Store({
    state: {
        loginApiUrl: process.env.VUE_APP_LOGIN_API_URL,
        docsApiUrl: process.env.VUE_APP_DOCS_API_URL,
        filesApiUrl: process.env.VUE_APP_FILES_API_URL,
        pricesApiUrl: process.env.VUE_APP_PRICES_API_URL,
        burReqApiUrl: process.env.VUE_APP_BUYREQ_API_URL,
        pazarVersionsApiUrl: process.env.VUE_APP_PAZARVERSIONS_API_URL,
        login: null,
        username: "",
        isAuthenticated: false,
        isPriceListSat: false,
        // priceList: [],
        cloudTypes: {
            Essential: {
                image: require('@/assets/img/pazarcloud-essential.jpg'),
                text: 'PazarCloud Essential',
                desc: 'مناسب فریلنسرها',
                link: '/purchaseform',
                price: 'ماهانه 300,000 تومان',
                info: '/cloudessential'
            },
            Growth: {
                image: require('@/assets/img/growth2.jpg'),
                text: 'PazarCloud Growth',
                desc: 'مناسب کسب و کارهای کوچک و در حال رشد',
                link: '/purchaseform',
                price: 'ماهانه 500,000 تومان',
                info: '/cloudgrowth'
            },
            Pro: {
                image: require('@/assets/img/pazarcloud-pro.png'),
                text: 'PazarCloud Pro',
                desc: 'مناسب کسب و کارهای حرفه‌ای',
                link: '/purchaseform',
                price: 'ماهانه 1,000,000 تومان',
                info: '/cloudpro'
            },
            // Starter: {
            //     image: require('@/assets/img/cards/pazar-asnaf.jpg'),
            //     text: 'طرح رایگان',
            //     desc: 'مناسب برای ثبت دخل و خرج شخصی',
            //     link: '/purchaseform',
            //     price: 'رایگان',
            //     info: '/cloudfree'
            // }
        },
        cloudModules: {
            ecApp: {
                image: require('@/assets/img/moduls/tolid.jpg'),
                text: 'اپ اختصاصی تجارت الکترونیک',
                desc: '',
                link: '/moduls/tolid',
                price: '25,000,000',
            },
            CRM: {
                image: require('@/assets/img/moduls/hoghugh.jpg'),
                text: 'CRM - مدیریت ارتباط با مشتری',
                desc: '',
                link: '/moduls/hoghugh',
                price: ' - '
            },
            'C.Branch': {
                image: require('@/assets/img/moduls/project.jpg'),
                text: 'ماژول شعب',
                desc: '',
                link: 'moduls/control',
                price: ' - '
            },
        },
        plusTypes: {
            rt: {
                image: require('@/assets/img/pazarplus-retail-card.jpg'),
                text: 'فروشگاهی',
                desc: 'مناسب فروشگاه ها و کسب و کارهای کوچک',
                link: '/purchaseform',
                price: '',
                info: '/pazarforushgahi'
            },
            or: {
                image: require('@/assets/img/pazarplus-business-card.jpg'),
                text: 'شرکتی',
                desc: 'مناسب شرکت ها و کسب و کارهای متوسط',
                link: '/purchaseform',
                price: '',
                info: '/pazarsherkati'
            },
            ind: {
                image: require('@/assets/img/pazarplus-ind-card.jpg'),
                text: 'صنعتی',
                desc: 'مناسب کارخانجات و کارگاههای تولیدی',
                link: '/purchaseform',
                price: '',
                info: '/pazarsanati'
            },
            as: {
                image: require('@/assets/img/cards/pazar-asnaf.jpg'),
                text: 'اصناف',
                desc: 'مناسب اصناف',
                link: '/purchaseform',
                price: '',
                info: '/pazarasnaf'
            }
        },
        plusModules: {
            prd: {
                image: require('@/assets/img/moduls/tolid.jpg'),
                text: 'ماژول تولید',
                desc: '',
                link: '/moduls/tolid',
                price: ''
            },
            py: {
                image: require('@/assets/img/moduls/hoghugh.jpg'),
                text: 'ماژول حقوق و دستمزد',
                desc: '',
                link: '/moduls/hoghugh',
                price: ''
            },
            pc: {
                image: require('@/assets/img/moduls/project.jpg'),
                text: ' ماژول کنترل پروژه ',
                desc: '',
                link: 'moduls/control',
                price: ''
            },
            hs: {
                image: require('@/assets/img/moduls/tablet.jpg'),
                text: ' ماژول پخش مویرگی با لایسنس 5 تبلت',
                desc: '',
                link: '/moduls/pakhshmuyragi',
                price: ''
            },
            ds: {
                image: require('@/assets/img/moduls/pakhsh.jpg'),
                text: 'ماژول پخش',
                desc: '',
                link: '/moduls/pakhsh',
                price: ''
            },
            cb: {
                image: require('@/assets/img/moduls/BI.jpg'),
                text: 'ماژول پشتیبان گیری ابری',
                desc: '',
                link: '',
                price: ''
            },
            op: {
                image: require('@/assets/img/moduls/optic.jpg'),
                text: ' ماژول اپتیک',
                desc: '',
                link: '/moduls/optic',
                price: ''
            },
            cr: {
                image: require('@/assets/img/moduls/chandarzi.jpg'),
                text: ' ماژول چندارزی',
                desc: '',
                link: '/moduls/chandarzi',
                price: ''
            },
            n2: {
                image: require('@/assets/img/moduls/shabake.jpg'),
                text: 'ماژول شبکه',
                desc: '',
                link: '/moduls/shabake',
                price: ''
            },
            nu: {
                image: require('@/assets/img/moduls/shabake2.jpg'),
                text: 'لایسنس هر کاربر شبکه',
                desc: '',
                link: '/moduls/shabake',
                price: ''
            },
            rs: {
                image: require('@/assets/img/moduls/restaurant.jpg'),
                text: 'ماژول رستوران',
                desc: '',
                link: 'moduls/restaurant',
                price: ''
            },
            tr: {
                image: require('@/assets/img/moduls/tablet1.jpg'),
                text: 'لایسنس تبلت رستوران',
                desc: '',
                link: 'moduls/restaurant',
                price: ''
            },
            co: {
                image: require('@/assets/img/moduls/shobe2.jpg'),
                text: 'مدیریت شعبه و مرکز',
                desc: '',
                link: '/moduls/shobemarkaz',
                price: ''
            },
            br: {
                image: require('@/assets/img/moduls/shobe1.jpg'),
                text: 'ماژول شعبه',
                desc: '',
                link: '',
                price: ''
            },
            sc: {
                image: require('@/assets/img/moduls/campaign.jpg'),
                text: 'ماژول کمپین و جشنواره',
                desc: '',
                link: '/moduls/campaign',
                price: ''
            },
            gp: {
                image: require('@/assets/img/moduls/kala.jpg'),
                text: 'ماژول ویژگی های کالا',
                desc: '',
                link: '',
                price: ''
            }
        },
        v12Types: {
            f4: {
                image: require('@/assets/img/cards/pazar-forushgahi.jpg'),
                text: 'فروشگاهی ويژه',
                desc: '',
                link: '/purchaseform',
                price: '',
                info: '/pazarforushgahi'
            },
            c4: {
                image: require('@/assets/img/cards/pazar-sherkati.jpg'),
                text: 'شرکتی ويژه',
                desc: '',
                link: '/purchaseform',
                price: '',
                info: '/pazarsherkati',
            }
        },
        v12Modules: {
            t: {
                image: require('@/assets/img/moduls/tolid.jpg'),
                text: 'ماژول تولید',
                desc: '',
                link: '/moduls/tolid',
                price: ''
            },
            y: {
                image: require('@/assets/img/moduls/hoghugh.jpg'),
                text: 'ماژول حقوق و دستمزد',
                desc: '',
                link: '/moduls/hoghugh',
                price: ''
            },
            p2: {
                image: require('@/assets/img/moduls/pakhsh.jpg'),
                text: 'ماژول پخش حرفه ای',
                desc: '',
                link: '/moduls/pakhsh',
                price: ''
            },

            a: {
                image: require('@/assets/img/moduls/ghest.jpg'),
                text: ' ماژول فروش اقساطی',
                desc: '',
                link: '',
                price: ''
            },
            o: {
                image: require('@/assets/img/moduls/optic.jpg'),
                text: ' ماژول اپتیک ',
                desc: '',
                link: '/moduls/optic',
                price: ''
            },
            b: {
                image: require('@/assets/img/moduls/anbar.jpg'),
                text: ' ماژول مدیریت شماره سریال انبار ',
                desc: '',
                link: '',
                price: ''
            },
            n2: {
                image: require('@/assets/img/moduls/shabake.jpg'),
                text: 'ماژول شبکه',
                desc: '',
                link: '/moduls/shabake',
                price: ''
            },
            n: {
                image: require('@/assets/img/moduls/shabake2.jpg'),
                text: ' لایسنس هر کاربر شبکه',
                desc: '',
                link: '',
                price: ''
            }
        },
        products: [],
        plusKits: [],
        cloudKits: [],
        v12Kits: [],
        filesLinks: [],
        docsList: [],
        pazarVersions: []
    },
    mutations: {
        setLogin(state, payload) {
            state.login = payload;
            state.username = (payload && payload.fullName) ? payload.fullName : "";
            localStorage.login = JSON.stringify(payload);
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setPriceList(state, payload) {
            // state.priceList = payload;
            const priceList = payload;
            // console.info('priceList', priceList)
            // alert(`priceList.length:  ${priceList.length}`);

            // let myPrice = state.priceList  //this.$store.state.priceList;
            try {
                for (let index = 0; index < priceList.length; index++) {
                    // if (index > 52) alert(`index:  ${index} element.Code: ${element.Code}`);
                    const element = priceList[index];

                    if (element.Code) {
                        const code = element.Code.toLowerCase();
                        const id = element.KitId;
                        const name = element.Title.replace(/12/g, '')
                        const groupId = element.ProductId
                        const price = element.Price
                        // Pazar Cloud:
                        if (element.ProductId === 10000) {
                            //Pazar Cloud Types
                            if (state.cloudTypes[code]) {
                                state.cloudTypes[code].price = price
                                state.products.push({ type: 'cloud', baseName: 'پازارکلاد', code, name, price, id, groupId })
                            }
                            //Pazar Cloud Modules
                            if (state.cloudModules[code]) {
                                state.cloudModules[code].price = price
                                state.cloudKits.push({ type: 'cloud', baseName: 'پازارکلاد', code, name, price, id, groupId })
                            }
                        }
                        // Pazar Plus:
                        else if (element.ProductId === 5) {
                            //Pazar Plus Types
                            if (state.plusTypes[code]) {
                                state.plusTypes[code].price = price
                                state.products.push({ type: 'plus', baseName: 'پازارپلاس', code, name, price, id, groupId })
                            }
                            //Pazar Plus Modules
                            if (state.plusModules[code]) {
                                state.plusModules[code].price = price
                                state.plusKits.push({ type: 'plus', baseName: 'پازارپلاس', code, name, price, id, groupId })
                            }
                        }
                        // Pazar v12
                        else if (element.ProductId === 3) {
                            //Pazar v12 Types
                            if (state.v12Types[code]) {
                                state.v12Types[code].price = price
                                state.products.push({ type: '12', baseName: 'پازار١٢ (قدیمی)', code, name, price, id, groupId })
                            }
                            //Pazar v12 Modules
                            if (state.v12Modules[code]) {
                                state.v12Modules[code].price = price
                                state.v12Kits.push({ type: '12', baseName: 'پازار١٢', code, name, price, id, groupId })
                            }
                        }
                    }
                }
                // alert(`plusModules.prd.price: ${plusModules.prd.price}`);
            } catch (error) {
                // alert(`Error Reading Data File: ${JSON.stringify(error)}`);
                console.info(error)
                // alert(`Error Reading Data File (SetPriceList)`);
            }
        },
        setFilesLinks(state, payload) {
            state.filesLinks = payload;
        },
        setPazarVersions(state, payload) {
            state.pazarVersions = payload;
        },
        setDocsList(state, payload) {
            for (let index = 0; index < payload.length; index++) {
                let element = payload[index];
                element.date = (new Date(element.date)).toJSON().substring(0, 10)
            }
            // console.info(payload)
            state.docsList = payload;
        }
    },
    actions: {
        async checkLoged({ commit }) {
            const loginPayload = (localStorage.login) ? JSON.parse(localStorage.login) : null
            const loginTime = (loginPayload && loginPayload.dateTime) ? Date.now() - new Date(loginPayload.dateTime).getTime() : false
            if (loginTime && loginTime < (24 * 60 * 60 * 1000)) { // Max 24 Hour Login Time
                // console.info(loginPayload.dateTime)
                // console.info(new Date(loginPayload.dateTime).getTime())
                // console.info(Date.now())
                // console.info(loginTime)
                commit('setLogin', loginPayload);
                commit('setIsAuthenticated', true);
            } else {
                commit('setLogin', null);
                commit('setIsAuthenticated', false);
            }
        },
        async userLogout({ commit }) {
            commit('setLogin', null);
            commit('setIsAuthenticated', false);
            if (window.location.pathname !== '/') router.push('/');
        },
        async userLogin({ state, commit }, { domain, username, password }) {
            try {
                const reqDateTime = new Date()
                const hashedPass = cryptojs.SHA256(password).toString()
                // console.info(` Password: ${hashedPass}`)
                // let response = await axios.post(`${state.loginApiUrl}`, {
                let response = await axios.post(state.loginApiUrl, {
                    "Username": username,
                    "Password": hashedPass,
                    "Domain": domain
                });
                if (response) {
                    // response.data = {
                    //     "DateTime": "Mon, 13 Jul 2020 15:27:33 GMT",
                    //     "Message": {
                    //         "Code": "1",
                    //         "Token": "...gqX2L5Q...",
                    //         "UserId": 48,
                    //         "FullName": "کاربر دمو"
                    //     },
                    //     "Result": "True",
                    //     "RecordId": null
                    // }

                    const rsp = response
                    const data = (rsp.data) ? rsp.data : {}
                    const msg = JSON.parse(data.Message)

                    // console.info(rsp,data, msg)

                    if (msg.Code == "1") {
                        const loginPayload = {
                            dateTime: reqDateTime, //data.DateTime,
                            token: msg.Token,
                            fullName: msg.FullName,
                            userId: msg.UserId
                        }
                        commit('setLogin', loginPayload);
                        commit('setIsAuthenticated', true);
                        return true
                    } else {
                        if (msg.Code == "2") { // alert("Invalid Username or Password")
                        } else if (msg.Code == "3") { // alert("User is Passive")
                        } else if (msg.Code == "4") { // alert("Organization is Passive")
                        }
                        commit('setLogin', null);
                        commit('setIsAuthenticated', false);
                        // alert(`Login Failed. Error Code: ${msg.Code}`)
                    }
                }
                return false
            } catch (error) {
                console.info(error)
                commit('setLogin', null);
                commit('setIsAuthenticated', false);
                // alert("Login Failed. ")
                return false
            }
        },
        async getPriceList({ state, commit }, productCode) {
            // console.log("PriceList Called...")
            if (!productCode) productCode = null
            if (!state.isPriceListSat) {
                try {
                    let response = await axios.get(`${state.pricesApiUrl}`, {});
                    state.isPriceListSat = true;
                    commit('setPriceList', response.data.priceList);
                } catch (error) {
                    state.isPriceListSat = false;
                    // commit('setPriceList', []);
                }
            }
        },
        async getFilesLinks({ state, commit }) {
            try {
                let axiosResponse = await axios.get(state.filesApiUrl, { params: {}, });
                // console.info('axiosResponse', axiosResponse.data)
                commit('setFilesLinks', axiosResponse.data.downloadLinks);

            } catch (error) {
                // alert(`Error Reading Data File: ${JSON.stringify(error)}`);
            }
        },
        async getPazarVersions({ state, commit }) {
            try {
                let axiosResponse = await axios.get(state.pazarVersionsApiUrl, { params: {}, });
                let data = axiosResponse.data.Message
                // console.info('PazarVersions', data)
                data.sort((a, b) => {
                    let x = '',
                        y = '',
                        xArray = a.version.trim().split('.'),
                        yArray = b.version.trim().split('.')

                    for (let index = 0; index < xArray.length; index++) {
                        x = x + '.' + xArray[index].padStart(10, '0')
                    }
                    for (let index = 0; index < yArray.length; index++) {
                        y = y + '.' + yArray[index].padStart(10, '0')
                    }

                    if (x > y) { return -1 } else { return 1 }
                })
                commit('setPazarVersions', axiosResponse.data.Message);
            } catch (error) {
                // alert(`Error Reading Data File: ${JSON.stringify(error)}`);
            }
        },
        async getDocs({ state, commit }) {
            try {
                if (state.isAuthenticated) {
                    const token = (localStorage.login) ? JSON.parse(localStorage.login).token : ''
                    if (token && token.length > 3) {
                        // const url = state.docsApiUrl + '/list?token=' + token
                        // const response = await axios.post(url);
                        // response.data = {
                        //     "DateTime": "Sat, 18 Jul 2020 12:52:42 GMT",
                        //     "Message": {"total":1,"rows":[{"documentDetailId":1,"name":"نصب پازار","desc":"شرح کامل نصب پازار","projects":" Pazar, CRM","tags":"#پازار","version":"20.07.18","date":"2020-07-18T00:00:00+04:30"}]},
                        //     "Result": true,
                        //     "RecordId": null
                        // }
                        const url = state.docsApiUrl + '/List'
                        // console.info(token)
                        const response = await axios({
                            method: "post",
                            url: url,
                            data: {},
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": `Bearer ${token}`,
                            }
                        })
                        // console.info(response)
                        if (response.status == 200) {
                            if (response.data && response.data.Result && response.data.Message && response.data.Message.rows) {
                                // const data = (response.data) ? response.data : {}
                                const dataRows = response.data.Message.rows
                                // console.info(dataRows)
                                commit('setDocsList', dataRows);
                            }
                        }
                    }
                }
            } catch (err) {
                // alert(`Error Reading Data File (getDocs): ${JSON.stringify(err)}`);
                console.info(err)
                // alert(`Error Reading Data File (getDocs)`);
            }
        },
        async getDoc({ state }, { data, fileName }) {
            try {
                if (state.isAuthenticated) {
                    const token = (localStorage.login) ? JSON.parse(localStorage.login).token : null
                    if (token && token.length > 3) {
                        const url = state.docsApiUrl + '/View'
                        await axios({
                            method: "post",
                            url: url,
                            data: data,
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": `Bearer ${token}`,
                            },
                            responseType: 'arraybuffer'
                        }).then(response => {
                            let data = response.data

                            // let i, j
                            // i = data.indexOf('/Author (')
                            // if (i > -1) {
                            //     j = data.indexOf(')', i)
                            //     if (j > -1) data.replace(data.substr(i, j - i + 1), '/Author (Rqm)')
                            // }
                            // i = data.indexOf('/Producer (')
                            // if (i > -1) {
                            //     j = data.indexOf(')', i)
                            //     if (j > -1) data.replace(data.substr(i, j - i + 1), '/Producer (Rqm)')
                            // }
                            // i = data.indexOf('/Title (')
                            // if (i > -1) {
                            //     j = data.indexOf(')', i)
                            //     if (j > -1) data.replace(data.substr(i, j - i + 1), `/Title (${fileName})`)
                            // }

                            let blob = new Blob([data], { type: 'application/pdf' })
                            var URL = window.URL || window.webkitURL;
                            const downloadUrl = URL.createObjectURL(blob);

                            // 1.
                            let newWindow = window.open(downloadUrl + '#' + fileName, '_blank')
                            // console.info(newWindow)
                            newWindow.document.title = fileName

                            // 2.
                            const a = document.createElement("a");
                            a.target = "_blank";
                            a.download = fileName;
                            a.style.position = 'fixed';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            URL.revokeObjectURL(downloadUrl);


                        }).catch(err => {
                            console.info(err)
                            // alert(`1.Error Reading Data File (getDoc)`);
                        })

                        // console.info(1.1, response)
                        // if (response.status == 200 && response.data) {
                        //     // const doc = response.data
                        //     // console.info(1.3, doc)
                        //     return response.data;

                        // } else {
                        //     return null
                        // }
                    }
                }
            } catch (err) {
                // alert(`2.Error Reading Data File (getDocs): ${JSON.stringify(err)}`);
                console.info(err)
                // alert(`2.Error Reading Data File (getDoc)`);
                // return null
            }
        },
        async insertBuyReq({ state }, { data }) {
            try {
                const url = state.burReqApiUrl
                const response = await axios({
                    method: "post",
                    url: url,
                    data: data,
                    headers: {
                        'Content-Type': 'application/json',
                        // "Authorization": `Bearer ${token}`,
                    },
                })
                // console.info(response)
                if (response) {
                    let data = response.data
                    return data
                }
                return false
            } catch (err) {
                console.info(err)
                return false
            }
        }
    },
    // getters: {
    //     isAuthenticated(state) {
    //         return state.isAuthenticated //state.user !== null && state.user !== undefined;
    //     }
    // }
});